import React, { Fragment, lazy, Suspense } from 'react';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const ProductDetails = lazy(()=>import('../../components/ProductDetails/ProductDetails'))

const ProductDetailsPage = () => {
    return (
        <Fragment>
            <Suspense fallback={<LazyLoader/>}>
                <ProductDetails/>
            </Suspense>
        </Fragment>
    );
};

export default ProductDetailsPage;